module.exports = __webpack_public_path__ + "img/637598_B7C4D3_22293A_9BACBF-256px.8ed9a73b.png";